import { PlatformLocation } from '@angular/common';
import { Component, Inject, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import { ResumoPedido } from 'src/app/models/resumoPedido';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { AnexoModalComponent } from '../anexo-modal/anexo-modal.component';
import { CodFinameModalComponent } from '../cod-finame-modal/cod-finame-modal.component';
import { PedidoRecebimentoModalComponent } from '../pedido-recebimento-modal/pedido-recebimento-modal.component';
import { ResumoFinanceiroModalComponent } from '../resumo-financeiro-modal/resumo-financeiro-modal.component';
import { GlobalService } from './../../services/global.service';
import { ObsModalComponent } from './../obs-modal/obs-modal.component';
import { VendaDiretaModalComponent } from 'src/app/modals/venda-direta-modal/venda-direta-modal.component';
import { Cliente } from 'src/app/models/cliente';
import { AtualizarPrevisaoEntregaModalComponent } from '../atualizar-previsao-entrega-modal/atualizar-previsao-entrega-modal.component';
import { ItemPedido } from 'src/app/models/pedido';
import { MultiFormaPagamentoModalComponent } from '../multi-forma-pagamento-modal/multi-forma-pagamento-modal.component';
import { ProdutoService } from 'src/app/services/produto.service';
import { VendaEntrega } from 'src/app/models/venda-entrega';
import { InvalidoEstoqueMinimo } from 'src/app/models/invalido-estoque-minimo';
import { QuestionarioService } from 'src/app/services/questionario.service';
import { VendaPergunta } from 'src/app/models/venda-pergunta';
import { VendaResposta } from 'src/app/models/venda-resposta';
import { Produto, ProdutoKit } from 'src/app/models/produto';
import { ProdutoBloqueado } from 'src/app/models/produto-bloqueado';
import { CRMHierarquiaUsuario } from 'src/app/models/crmhierarquia-usuario';
import { CRMHierarquiaUsuarioService } from 'src/app/services/crmhierarquia-usuario.service';
import { Funcionario } from 'src/app/models/funcionario';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import { TermoAceiteListaModalComponent } from '../termo-aceite-lista-modal/termo-aceite-lista-modal.component';
import { VoucherService } from 'src/app/services/voucher.service';
import { PremissasUsuario } from 'src/app/models/premissas-usuario';
import { ClienteService } from 'src/app/services/cliente.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { Router } from '@angular/router';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { EtapaDoPedido } from 'src/app/models/enum';


declare const $: any;

@Component({
  selector: 'app-resumo-modal',
  templateUrl: './resumo-modal.component.html',
  styleUrls: ['./resumo-modal.component.scss']
})
export class ResumoModalComponent implements OnInit, AfterViewInit {

  public config: PerfectScrollbarConfigInterface = {};

  resumo: ResumoPedido = new ResumoPedido();
  lider: Funcionario = new Funcionario();
  somenteLeitura = false;
  texto = '';
  voltouProTopo = false;

  imprimirResumo = false;

  ocultarValores = true;
  mostrarDescontoItens = false;

  bloquearTipoFreteVendaDireta = false;

  integrador = false;

  itensComposicao: ProdutoKit[] = [];

  comprovanteObrigatorio = false;

  subTotalItensBruto = 0;
  subTotalItensLiquido = 0;
  mostrarValores = false;
  concordarTermos = false;
  exibirConcordarTermos = false;
  mostrarResumoFinanceiro = false;
  mostrarCodErp: false;
  mostrarRecebimentos = false;
  podeEditarRecebimentos = false;
  numeroSerie = '';
  mostrarNumeroSerie = false;
  mostrarObsNoItem = false;
  mostrarPrevisaoEntrega = false;
  podeEditarVendaDireta = false;

  multiFornecedores = false;
  pCentroDistribuicao = false;

  pDispEstoque = false;

  subTotalSeguros = 0;

  tipo = undefined;

  pUsarEstoqueMinimo = false;
  pBloqPedidoSemEstoqueDisp = false;

  idCupom;
  itensPedido: ItemPedido[] = [];
  enderecoDeEntrega: VendaEntrega = new VendaEntrega();

  pedirCodErpIntegracao = false;
  informarDadosSeparacao = false;

  usarSeguro = false;

  usarQuestionarioEntrega = false;
  camposQuestionariosObrigatorio = false;
  questionarioAberto = false;

  vendaProgramada = false;
  estoqueUnicoLote = false;

  perguntasOriginais: VendaPergunta[] = [];
  perguntas: VendaPergunta[] = [];
  respostasOriginais: VendaResposta[] = [];
  respostas: VendaResposta[] = [];

  comboSimOuNao = [
    { id: 'N', descricao: 'Não' },
    { id: 'S', descricao: 'Sim' }
  ];

  @ViewChild('perfectScrollResumo', { static: false }) perfectScroll: PerfectScrollbarComponent;

  produtosBloqueados = [];

  premissasSistema = new PremissasSistema();
  premissasUsuario = new PremissasUsuario();

  textoTipoCIF = '';
  podeAplicarVoucher = false;
  suporte = false;
  administrador = false;
  usuarioLogado: UsuarioLogado;

  constructor(
    public dialogRef: MatDialogRef<ResumoModalComponent>,
    private relatorioService: RelatorioService,
    private globalService: GlobalService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private pedidoService: PedidoService,
    private utilitarioService: UtilitarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private platformLocation: PlatformLocation,
    public dialog: MatDialog,
    private premissasService: PremissasService,
    private produtoService: ProdutoService,
    private questionarioService: QuestionarioService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private voucherService: VoucherService,
    private clienteService: ClienteService,
    private funcionarioService: FuncionarioService,
    private router: Router
  ) {
    this.exibirConcordarTermos = data.exibirConcordarTermos;
    this.mostrarResumoFinanceiro = data.mostrarResumoFinanceiro;
    this.mostrarRecebimentos = data.mostrarRecebimentos;
    this.podeEditarRecebimentos = data.podeEditarRecebimentos;
    this.mostrarPrevisaoEntrega = data.mostrarPrevisaoEntrega;
    this.bloquearTipoFreteVendaDireta = data.bloquearTipoFreteVendaDireta;



    this.tipo = data.tipo;
    this.idCupom = data.idCupom;
  }

  ngAfterViewInit(): void {
    // this.perfectScroll.directiveRef.scrollToTop(0,100);
  }

  buscarEnderecoDeEntrega() {
    this.carregandoService.mostra('buscarEnderecoDeEntrega');
    this.pedidoService.buscarEnderecoDeEntrega(this.idCupom).subscribe(f => {
      this.enderecoDeEntrega = f;
      this.carregandoService.esconde('buscarEnderecoDeEntrega');
    }, (erro) => {
      this.carregandoService.esconde('buscarEnderecoDeEntrega');
      this.notificacaoService.erro(erro);
    });
  }

  voltarProTopo() {
    if (!this.voltouProTopo) {
      this.perfectScroll.directiveRef.scrollToTop(0, 0);
      this.voltouProTopo = true;
    }
  }

  async ngOnInit() {
    this.podeEditarVendaDireta = (await this.globalService.consultaUsuario()).podeEditarVendaDireta;

    this.buscarPremissaQuestionario();

    await this.buscarPremissasSistema();
    await this.buscarPremissasUsuario();

    await this.buscarPremissaBloqPedidoSemEstoqueDisp();
    await this.buscarPremissaUsarEstoqueMinimo();

    await this.buscarVendaProgramada();
    await this.buscarEstoqueUnicoLote();

    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.buscarUsarSeguro();

    this.buscarMultiFornecedores();
    this.buscarPremissaCentroDeDistribuicao();

    this.buscarPedirCodErpIntegracao();
    this.buscarInformarDadosSeparacao();

    this.buscarMostrarNumeroSerie();
    this.buscarComprovanteConfirmacaoObg();
    this.integrador = await this.globalService.integrador();
    this.administrador = await this.globalService.administrador();
    this.suporte = await this.globalService.suporte();
    this.buscarVerPrecosProdutos();
    this.buscarMostrarCodErp();
    this.texto = this.integrador ? 'Orçamento' : 'Pedido';
    this.buscarEnderecoDeEntrega();

    this.ocultarValores = this.data.ocultarValores;
    this.mostrarDescontoItens = this.data.mostrarDescontoItens;

    this.buscarResumo();
    this.buscarObsNoItem();
    this.buscarPremissaDispEstoque();
  }

  async buscarPremissasUsuario() {
    try {
      this.carregandoService.mostra('buscarPremissasUsuario');
      this.premissasUsuario = await this.premissasService.consultarPremissasUsuario().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasUsuario');
    }
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  buscarLider() {
    this.carregandoService.mostra("mostraLider");
    this.hierarquiaService.buscarSuperior(this.resumo.idVendedor).subscribe(data => {
      this.carregandoService.esconde("mostraLider");
      this.lider = data;
    }, (erro) => {
      this.carregandoService.esconde("mostraLider");
      this.notificacaoService.erro("Não foi possível buscar o líder");
    });
  }

  async buscarVendaProgramada() {
    try {
      this.carregandoService.mostra('buscarVendaProgramada');
      this.vendaProgramada = (await this.premissasService.consultarVendaProgramada().toPromise()).valor;
      this.carregandoService.esconde('buscarVendaProgramada');
    } catch (erro) {
      this.carregandoService.esconde('buscarVendaProgramada');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarEstoqueUnicoLote() {
    try {
      this.carregandoService.mostra('buscarEstoqueUnicoLote');
      this.estoqueUnicoLote = (await this.premissasService.consultarEstoqueUnicoLote().toPromise()).valor;
      this.carregandoService.esconde('buscarEstoqueUnicoLote');
    } catch (erro) {
      this.carregandoService.esconde('buscarEstoqueUnicoLote');
      this.notificacaoService.erro(erro);
    }
  }

  buscarUsarSeguro() {
    this.carregandoService.mostra('buscarUsarSeguro');

    this.premissasService.consultarUsarSeguro().subscribe(
      dados => {
        if (dados.valor) {
          this.usarSeguro = true;
        }

        this.carregandoService.esconde('buscarUsarSeguro');
      },
      err => {
        this.carregandoService.esconde('buscarUsarSeguro');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarPedirCodErpIntegracao() {
    this.carregandoService.mostra('buscarPedirCodErpIntegracao');
    this.premissasService.consultarPedirCodErpIntegracao().subscribe(
      (f) => {
        this.pedirCodErpIntegracao = f.valor;

        this.carregandoService.esconde('buscarPedirCodErpIntegracao');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPedirCodErpIntegracao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarInformarDadosSeparacao() {
    this.carregandoService.mostra('buscarInformarDadosSeparacao');
    this.premissasService.consultarInformarDadosSeparacao().subscribe(
      (f) => {
        this.informarDadosSeparacao = f.valor;

        this.carregandoService.esconde('buscarInformarDadosSeparacao');
      },
      (erro) => {
        this.carregandoService.esconde('buscarInformarDadosSeparacao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaDispEstoque() {
    this.carregandoService.mostra('buscarPremissaDispEstoque');

    this.premissasService.consultarDispEstoque().subscribe(
      resp => {
        if (resp.valor) {
          this.pDispEstoque = true;
        }

        this.carregandoService.esconde('buscarPremissaDispEstoque');
      },
      err => {
        this.carregandoService.esconde('buscarPremissaDispEstoque');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarMultiFornecedores() {
    this.carregandoService.mostra('consultarMultiFornecedores');
    this.premissasService.consultarMultiFornecedores().subscribe(
      (f) => {
        this.multiFornecedores = f.valor;

        this.carregandoService.esconde('consultarMultiFornecedores');
      },
      (erro) => {
        this.carregandoService.esconde('consultarMultiFornecedores');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');
    this.premissasService.consultarCentroDeDistribuicao().subscribe(f => {
      this.pCentroDistribuicao = f.valor;

      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
    }, (erro) => {
      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
      this.notificacaoService.erro(erro);
    });
  }

  resumoFinanceiroDoPedido() {

    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ResumoFinanceiroModalComponent, {
      width: (($('body').width()).toString() + 'px'),
      data: { idCupom: this.resumo.idCupom, valorTotal: this.resumo.valorTotal },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {

      }
    });
  }

  async buscarResumo() {
    this.carregandoService.mostra('buscarResumo');

    this.somenteLeitura = this.data.somenteLeitura;
    await this.buscarPerguntasEntrega();

    this.pedidoService.consultarResumo(this.data.idCupom).subscribe(
      async (res) => {
        this.resumo = res;
        this.resumo.itens.forEach(p => {
          this.subTotalItensBruto += p.vTotalBruto;
          this.subTotalItensLiquido += p.vTotal;
        });

        if (this.resumo.seguros !== null && this.resumo.seguros !== undefined) {
          this.resumo.seguros.forEach(p => {
            this.subTotalSeguros += p.valor;
          });
        }

        await this.buscarPodeAplicarVoucher();

        this.buscarRespostas();

        this.carregandoService.esconde('buscarResumo');
        this.buscarLider();
      },
      (erro) => {
        this.carregandoService.esconde('buscarResumo');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarRespostas() {
    if (this.resumo.respostas.length === 0) return;

    this.respostasOriginais = this.resumo.respostas;
    const tipoFrete = this.resumo.tipoFrete.includes('CIF') ? 0 : 1;

    this.respostas = this.respostasOriginais.filter(resposta => resposta.tipoQuest === tipoFrete);
    const idsPerguntasComResposta = this.respostas.map(resposta => resposta.idPergunta);

    this.perguntas = this.perguntasOriginais.filter(pergunta =>
      pergunta.tipoQuest === tipoFrete &&
      (idsPerguntasComResposta.includes(pergunta.id) || pergunta.status)
    );

    this.respostas.forEach(resposta => {
      const perguntaCorrespondente = this.perguntas.find(pergunta => pergunta.id === resposta.idPergunta);

      if (perguntaCorrespondente) {
        perguntaCorrespondente.respostaSN = resposta.respostaSN;
        perguntaCorrespondente.respostaTexto = resposta.respostaTexto;
      }
    });
  }

  buscarObsNoItem() {
    this.carregandoService.mostra('buscarObsNoItem');

    this.premissasService.consultarObsNoItem().subscribe(f => {

      this.mostrarObsNoItem = f.valor;

      this.carregandoService.esconde('buscarObsNoItem');

    }, (erro) => {

      this.carregandoService.esconde('buscarObsNoItem');

      this.notificacaoService.erro(erro);

    });
  }

  async validarEstoqueLoteUnico() {

    try {
      this.carregandoService.mostra('validarEstoqueLoteUnico');
      await this.pedidoService.calcularEstoqueLote(this.itensPedido, this.resumo.idFornecedor, this.resumo.idCupom, false).toPromise();
      return true;
    } catch (erro) {
      return false;
    } finally {
      this.carregandoService.esconde('validarEstoqueLoteUnico');
    }


  }


  async confirmarPedido(enviarAnexo) {

    if (await this.verificarSeTemProdutoBloqueado(this.idCupom)) {
      return;
    }

    if (this.pBloqPedidoSemEstoqueDisp || this.pUsarEstoqueMinimo) {
      await this.buscarItens();
      await this.buscarItensComposicao();
    }

    if (this.pBloqPedidoSemEstoqueDisp) {
      const itensSemEstoque: string[] = this.buscarItensSemEstoqueDisp();

      if (itensSemEstoque.length > 0) {
        swal({
          title: 'ATENÇÃO!',
          html: 'Existem itens sem estoque disponível! </br></br>' + (!this.integrador ? itensSemEstoque.join('</br>') : 'Entre em contato com o seu vendedor!'),
          type: 'warning',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Fechar',
          buttonsStyling: false
        }).then((result) => {
          if (result.value) { }
        });

        return;
      } else if (this.vendaProgramada && this.estoqueUnicoLote && !(await this.validarEstoqueLoteUnico())) {
        swal({
          title: 'ATENÇÃO!',
          html: 'Existem itens sem estoque disponível para um único lote! </br></br>' + (!this.integrador ? '' : 'Entre em contato com o seu vendedor!'),
          type: 'warning',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Fechar',
          buttonsStyling: false
        }).then((result) => {
          if (result.value) { }
        });

        return;
      }
    }

    if (this.pUsarEstoqueMinimo) {
      const invalidos: InvalidoEstoqueMinimo[] = this.buscarItensInvalidosEstoqueMinimo();

      if (invalidos.length > 0) {
        this.enviarAvisoEstoqueMinimo({ idCupom: this.resumo.idCupom, itens: invalidos });
      }
    }

    const mensagem = 'Deseja realmente CONFIRMAR o Pedido?';
    swal({
      title: 'ATENÇÃO!',
      text: mensagem,
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then(async (result) => {
      if (result.value) {

        if (this.resumo.ordemEtapa === EtapaDoPedido.Editando && !(await this.validarParaConfirmar())) {
          return;
        }

        if (enviarAnexo || (!this.integrador && this.comprovanteObrigatorio)) {
          const largura = Number(($('body').width()));

          const dialogRef = this.dialog.open(AnexoModalComponent, {
            width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
            data: { idCupom: this.resumo.idCupom },
            panelClass: 'modal-card'
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.confirmar(result);
            }
          });
        } else {
          this.confirmar(false);
        }
      }
    });
  }

  async validarParaConfirmar() {

    if (this.resumo.origemGI === 0 && this.premissasUsuario.validarKitCustomizadoEdicaoPedido && !(await this.validarCombinacao())) {
      return false;
    }

    if (this.premissasUsuario.buscarEnderecoSomentePorReceita) {
      const dadosDesatualizados = await this.clienteService.forcaAtualizacaoReceita(this.resumo.idCliente).toPromise();

      if (dadosDesatualizados.result) {
        const temPermissao = this.suporte || this.administrador || await this.funcionarioService.consultaPodeAcessarCadastroIntegrador(this.usuarioLogado.id).toPromise();

        swal({
          title: 'ATENÇÃO!',
          text: 'É necessário atualizar o cadastro deste integrador na Receita Federal!',
          type: 'warning',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Prosseguir',
          buttonsStyling: false
        }).then((result) => {
          if (temPermissao) {
            this.router.navigate(['/integradores/editar', this.resumo.idCliente]);
            this.fechar();
          }
          else {
            this.notificacaoService.erro('Você não tem permissão para acessar a tela de cadastro de integradores. Por favor, entre em contato com um administrador para realizar a atualização necessária.');
          }
        });

        return false;
      }
    }


    return true;
  }

  async validarCombinacao() {

    try {
      this.carregandoService.mostra('validarCombinacao');
      await this.pedidoService.validarCombinacao(this.itensPedido).toPromise();
      this.carregandoService.esconde('validarCombinacao');
      return true;
    } catch (erro) {
      this.carregandoService.esconde('validarCombinacao');

      this.notificacaoService.erro(erro);

      if (!this.integrador && !this.premissasUsuario.travarValidarKitCustomizado) {
        const result = await swal({
          title: 'Atenção!!',
          text: 'Combinação está fora do padrão. Deseja continuar mesmo assim?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          buttonsStyling: false
        });

        return result.value;
      } else {
        return false;
      }
    }
  }

  // async verificaPrimeiroPedido(arquivo: any) {
  //   const cliente = this.resumo.idClienteFaturamento.toString();
  //   this.pedidoService.primeiroPedido(cliente).subscribe(resp => {
  //     if (resp) {
  //       swal({
  //         title: 'ATENÇÃO!',
  //         html: 'Para dar continuidade, é necessário fazer a assinatura. Deseja continuar?',
  //         type: 'warning',
  //         showCancelButton: false,
  //         confirmButtonClass: 'btn btn-danger',
  //         cancelButtonClass: 'btn btn-danger',
  //         confirmButtonText: 'Fechar',
  //         buttonsStyling: false
  //       }).then((result) => {
  //         if (result.value) { }
  //       });
  //     }
  //   }, (erro) => {

  //   });
  // }

  async confirmar(arquivo) {
    this.carregandoService.mostra('confirmaPedido');

    // await this.verificaPrimeiroPedido(null);

    this.pedidoService.confirmar(this.resumo.idCupom, 0,
      0, '', false, {}, true, false, arquivo, 0, [], [], this.resumo.dispEstoque, this.resumo.dataDispEstoque, null, null, null).subscribe((resp: any) => {

        this.carregandoService.esconde('confirmaPedido');
        this.notificacaoService.sucesso('Pedido Confirmado com sucesso!!!');
        this.dialogRef.close(true);
      }, (erro) => {
        this.carregandoService.esconde('confirmaPedido');
        this.notificacaoService.erro(erro);
      });
  }

  imprimirPedido() {
    this.carregandoService.mostra('imprimirPedido');

    this.relatorioService.pedido(this.resumo.idCupom).subscribe(resp => {

      this.notificacaoService.sucesso('Documento gerado com sucesso!!!');
      this.utilitarioService.openBlob(resp);

      this.carregandoService.esconde('imprimirPedido');



    }, (erro) => {
      const reader = new FileReader();

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement['result'];
        this.carregandoService.esconde('imprimirPedido');
        this.notificacaoService.erro(text);
      });

      // Start reading the blob as text.
      reader.readAsText(erro.error);
    });
  }

  imprimirResumoPedido() {
    this.carregandoService.mostra('imprimirResumoPedido');

    this.relatorioService.resumoDoPedido(this.tipo, this.resumo.idCupom, this.ocultarValores, this.mostrarDescontoItens).subscribe(resp => {

      this.notificacaoService.sucesso('Documento gerado com sucesso!!!');
      this.utilitarioService.openBlob(resp);

      this.carregandoService.esconde('imprimirResumoPedido');



    }, (erro) => {
      const reader = new FileReader();

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement['result'];
        this.carregandoService.esconde('imprimirResumoPedido');
        this.notificacaoService.erro(text);
      });

      // Start reading the blob as text.
      reader.readAsText(erro.error);
    });
  }

  abrirDadosVendaDireta() {
    if (!this.resumo.vendaDireta) {
      return;
    }

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(VendaDiretaModalComponent, {
      width: largura > 1100 ? '1000px' : (($('body').width()).toString() + 'px'),
      data: {
        clienteFaturamento: this.resumo.clienteFaturamento,
        veioDaTelaResumoModal: true
      },
      panelClass: 'modal-card',
      maxHeight: '95vh',
    });
    dialogRef.afterClosed().subscribe((
      result: Cliente
    ) => {
      if (result) {
        this.resumo.clienteFaturamento = result;
      }
    });
  }

  abrirModalEditarPrevisaoEntrega() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(AtualizarPrevisaoEntregaModalComponent, {
      width: largura > 600 ? '550px' : (($('body').width()).toString() + 'px'),
      data: {
        dataPrevisaoEntrega: this.resumo.previsaoEntrega,
        idCupom: this.resumo.idCupom
      },
      panelClass: 'modal-card',
      maxHeight: '95vh',
    });
    dialogRef.afterClosed().subscribe((
      result: Date
    ) => {
      if (result) {
        this.resumo.previsaoEntrega = result;
      }
    });
  }

  novaObservacao() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ObsModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: {
        tipo: 0,
        idCupom: this.resumo.idCupom
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.salvarObservacao(result);
      }
    });
  }

  salvarObservacao(observacao) {
    this.carregandoService.mostra('salvarObservacao');

    this.pedidoService.atualizarObservacao(this.resumo.idCupom, observacao, null, false).subscribe(
      (res) => {

        this.carregandoService.esconde('salvarObservacao');
        this.notificacaoService.sucesso('Mensagem enviada com sucesso!!!');
        this.buscarResumo();
      },
      (erro) => {
        this.carregandoService.esconde('salvarObservacao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarVerPrecosProdutos() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarVerPrecoProdutos().subscribe(f => {
      this.mostrarValores = f.valor;
      this.carregandoService.esconde('buscarVerPrecosProdutos');
    }, (erro) => {
      this.carregandoService.esconde('buscarVerPrecosProdutos');
      this.notificacaoService.erro(erro);
    });
  }

  baixarTermo() {

    this.carregandoService.mostra('termosDeUso');

    this.pedidoService.baixarTermo().subscribe(resp => {

      this.utilitarioService.openBlobModal(resp);

      this.carregandoService.esconde('termosDeUso');
    }, (erro) => {
      const reader = new FileReader();

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement['result'];
        this.carregandoService.esconde('termosDeUso');
        this.notificacaoService.erro(text);
      });

      // Start reading the blob as text.
      reader.readAsText(erro.error);
    });

    return false;
  }

  buscarMostrarCodErp() {
    this.carregandoService.mostra('buscarMostrarCodErp');
    this.premissasService.consultarMostrarCodErp().subscribe(f => {
      this.mostrarCodErp = f.valor;
      this.carregandoService.esconde('buscarMostrarCodErp');
    }, (erro) => {
      this.carregandoService.esconde('buscarMostrarCodErp');
      this.notificacaoService.erro(erro);
    });
  }

  buscarComprovanteConfirmacaoObg() {
    this.carregandoService.mostra('buscarComprovanteConfirmacaoObg');
    this.premissasService.consultarCompConfObg().subscribe(f => {
      this.comprovanteObrigatorio = f.valor;
      this.carregandoService.esconde('buscarComprovanteConfirmacaoObg');
    }, (erro) => {
      this.carregandoService.esconde('buscarComprovanteConfirmacaoObg');
      this.notificacaoService.erro(erro);
    });
  }

  exibirRecebimentos() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(PedidoRecebimentoModalComponent, {
      width: largura > 1050 ? '1000px' : (($('body').width()).toString() + 'px'),
      data: { idCupom: this.resumo.idCupom, podeEditarRecebimentos: this.podeEditarRecebimentos },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      // if (result) {
      //   this.buscarPedidos();
      // }
    });
  }



  editarCodFiname() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CodFinameModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: {
        idCupom: this.resumo.idCupom, codFiname: this.resumo.codFiname
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.resumo.codFiname = result;
      }
    });
  }

  buscarMostrarNumeroSerie() {
    this.carregandoService.mostra('buscarMostrarNumeroSerie');
    this.premissasService.consultarMostrarNumeroSerie().subscribe(f => {
      this.mostrarNumeroSerie = f.valor;
      this.carregandoService.esconde('buscarMostrarNumeroSerie');
    }, (erro) => {
      this.carregandoService.esconde('buscarMostrarNumeroSerie');
      this.notificacaoService.erro(erro);
    });
  }

  buscarItensInvalidosEstoqueMinimo(): InvalidoEstoqueMinimo[] {
    if (!this.pUsarEstoqueMinimo) {
      return [];
    }

    let invalidos: InvalidoEstoqueMinimo[] = [];

    this.itensPedido.filter(p => p.qt > 0).map((item: ItemPedido) => {

      if (item.produtoTela.familia === 7) {

        this.itensComposicao.filter(c => c.proKit === item.produto).map((itemComposicao: ProdutoKit) => {

          const disponivel = itemComposicao.produtoMP.qtEstoque - itemComposicao.produtoMP.qtReserva - (item.qt * itemComposicao.qt);

          if (itemComposicao.produtoMP.qtEstoqueMinimo > 0 && disponivel <= itemComposicao.produtoMP.qtEstoqueMinimo) {
            invalidos.push({
              descricao: itemComposicao.produtoMP.descricaoAtual,
              qtDisponivel: disponivel,
              qtEstoqueMinimo: itemComposicao.produtoMP.qtEstoqueMinimo
            });
          }

        });

      } else {

        const disponivel = item.produtoTela.qtEstoque - item.produtoTela.qtReserva - item.qt;

        if (item.qtEstoqueMinimo > 0 && disponivel <= item.qtEstoqueMinimo) {
          invalidos.push({
            descricao: item.produtoTela.descricao,
            qtDisponivel: disponivel,
            qtEstoqueMinimo: item.qtEstoqueMinimo
          });
        }
      }
    });

    return invalidos;
  }

  buscarItensSemEstoqueDisp(): string[] {
    let invalidos = [];

    this.itensPedido.filter(p => p.qt > 0).map((item: ItemPedido) => {

      if (item.produtoTela.familia === 7) {

        this.itensComposicao.filter(c => c.proKit === item.produto).map((itemComposicao: ProdutoKit) => {

          const resto = itemComposicao.produtoMP.qtEstoque - itemComposicao.produtoMP.qtReserva - (item.qt * itemComposicao.qt);

          if (resto < 0) {
            invalidos.push(itemComposicao.produtoMP.descricaoAtual);
          }

        });

      } else {

        const resto = item.produtoTela.qtEstoque - item.produtoTela.qtReserva - item.qt;

        if (resto < 0) {
          invalidos.push(item.produtoTela.descricaoAtual);
        }
      }
    });

    return invalidos;
  }

  buscarPremissaUsarEstoqueMinimo() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarPremissaUsarEstoqueMinimo');
      this.premissasService.consultarUsarEstoqueMinimo().subscribe(async f => {
        if (f.valor) {
          this.pUsarEstoqueMinimo = true;
        }

        this.carregandoService.esconde('buscarPremissaUsarEstoqueMinimo');
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('buscarPremissaUsarEstoqueMinimo');
        this.notificacaoService.erro(erro);
        reject();
      });
    });
  }

  // buscarPedido() {
  //   return new Promise((resolve, reject) => {
  //     this.carregandoService.mostra('buscaPedido');

  //     this.pedidoService.consultarCompleto(this.idCupom, true).subscribe(async orc => {
  //       this.itensPedido = orc.itens;
  //       this.carregandoService.esconde('buscaPedido');
  //       resolve();
  //     }, (erro) => {
  //       this.carregandoService.esconde('buscaPedido');
  //       this.notificacaoService.erro(erro);
  //       reject();
  //     });
  //   });
  // }

  buscarItens() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarItens');

      this.pedidoService.consultarItens(this.idCupom, true, true, false, false).subscribe(async itens => {
        this.itensPedido = itens;
        this.carregandoService.esconde('buscarItens');
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('buscarItens');
        this.notificacaoService.erro(erro);
        reject();
      });
    });
  }

  async buscarItensComposicao() {

    try {
      this.carregandoService.mostra('buscarItensComposicao');

      if (this.itensPedido.some(p => p.produtoTela.familia === 7)) {
        this.itensComposicao = await this.produtoService.buscarComposicoes(this.itensPedido.filter(p => p.produtoTela.familia === 7).map(p => p.produto), this.resumo.idFornecedor, this.resumo.idCupom).toPromise();
      } else {
        this.itensComposicao = [];
      }

      this.carregandoService.esconde('buscarItensComposicao');
    } catch (erro) {
      this.carregandoService.esconde('buscarItensComposicao');
      this.notificacaoService.erro(erro);
    }
  }

  abrirModalMultiFormasPagamento() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(MultiFormaPagamentoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { formasPagamentoMulti: this.resumo.formasPagamento, valorPedido: 0, editavel: false, naoExibirTotais: true },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  buscarPremissaBloqPedidoSemEstoqueDisp() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarPremissaBloqPedidoSemEstoqueDisp');
      this.premissasService.consultarBloqPedidoSemEstoqueDisp().subscribe(f => {
        if (f.valor) {
          this.pBloqPedidoSemEstoqueDisp = true;
        }

        this.carregandoService.esconde('buscarPremissaBloqPedidoSemEstoqueDisp');
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('buscarPremissaBloqPedidoSemEstoqueDisp');
        this.notificacaoService.erro(erro);
        reject();
      });
    });
  }

  enviarAvisoEstoqueMinimo(dados) {
    this.carregandoService.mostra('enviarAvisoEstoqueMinimo');
    this.produtoService.enviarAvisoEstoqueMinimo(dados).subscribe(f => {
      this.carregandoService.esconde('enviarAvisoEstoqueMinimo');
    }, (erro) => {
      this.carregandoService.esconde('enviarAvisoEstoqueMinimo');
      this.notificacaoService.erro(erro);
    });
  }

  buscarPerguntasEntrega(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarPerguntasEntrega');

      this.questionarioService.consultarLista().subscribe(perg => {
        this.perguntasOriginais = perg;

        this.carregandoService.esconde('buscarPerguntasEntrega');
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('buscarPerguntasEntrega');
        this.notificacaoService.erro(erro);
        reject();
      });
    });
  }

  buscarPremissaQuestionario() {
    this.carregandoService.mostra('buscarPremissaQuestionario');
    this.premissasService.consultarQuestionario().subscribe(f => {
      this.usarQuestionarioEntrega = f.usarQuestionarioEntrega;
      this.camposQuestionariosObrigatorio = f.respostasQuestionarioEntregaObg;

      if (this.camposQuestionariosObrigatorio) {
        this.questionarioAberto = true;
      }

      this.carregandoService.esconde('buscarPremissaQuestionario');
    }, (erro) => {
      this.carregandoService.esconde('buscarPremissaQuestionario');
      this.notificacaoService.erro(erro);
    });
  }

  async verificarSeTemProdutoBloqueado(idcupom) {
    try {
      this.carregandoService.mostra('verificarSeTemProdutoBloqueado');
      const produtosBloqueados = await this.produtoService.consultarProdutosBloqueadosPorIdCupom(idcupom).toPromise();
      if (produtosBloqueados.length > 0) {
        this.produtosBloqueados = produtosBloqueados;
        this.notificacaoService.aviso('Há produtos indispoíveis no pedido');
        return true;
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('verificarSeTemProdutoBloqueado');
    }
  }

  async buscarProdutosBloqueados(idcupom: string): Promise<ProdutoBloqueado[]> {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarProdutosBloqueados');
      this.pedidoService.consultarProdutosBloqueados(idcupom).subscribe((resp: any) => {
        this.produtosBloqueados = resp;
        this.carregandoService.esconde('buscarProdutosBloqueados');
        resolve(resp);
      }, (erro) => {
        this.carregandoService.esconde('buscarProdutosBloqueados');
        this.notificacaoService.erro(erro);
        reject([]);
      });
    });
  }

  abrirModalAceiteTermo() {
    const largura = Number(($('body').width()));

    this.dialog.open(TermoAceiteListaModalComponent, {
      width: largura > 970 ? '870px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card',
      data: { tipoVisualizacao: 2, tipoUsuario: 1, idUsuario: this.resumo.idCliente }
    });
  }

  async buscarPodeAplicarVoucher() {
    if (this.resumo.voucher !== null && this.resumo.voucher !== undefined) {
      this.podeAplicarVoucher = await this.voucherService.podeAplicarVouchers(this.resumo.idCliente).toPromise();
    }
  }
}
